import {z} from 'zod'

export const UploadFileFormSchema = z.object({
    title: z.string().min(1, 'errors:title_required')
})
export type UploadFileValidationSchema = z.infer<typeof UploadFileFormSchema>
